export default "__VITE_ASSET__70bdaea3__"